import {
  CLEAR_TEST_ROOMS,
  CLEAR_PROD_ROOMS,
  CLEAR_ROOMS
} from '@/store/mutation-types'
import { firebaseDb as db, firebaseTestDb as testDb } from '@/vendor/firebase'
import { firebaseAction } from 'vuexfire'
// import l from '@/vendor/logger'
import format from 'date-fns/format'
import ko from 'date-fns/locale/ko'
import * as _ from 'ramda'

const state = {
  prodRooms: {},
  testRooms: {}
}

const getters = {
  prodRooms (state) {
    return '.value' in state.prodRooms
      ? ''
      : _.omit(['.key'], state.prodRooms)
  },
  testRooms (state) {
    return '.value' in state.testRooms
      ? ''
      : _.omit(['.key'], state.testRooms)
  },
  prodRoomsLength (state) {
    return Object.keys(state.prodRooms).length
  },
  testRoomsLength (state) {
    return Object.keys(state.testRooms).length
  },
  formattedCreatedAt (state) {
    return target => {
      return key => {
        return format(
          state[target][key].createdAt,
          'MM/DD/dd HH:mm:ss',
          { locale: ko }
        )
      }
    }
  },
  formattedStartedAt (state) {
    return target => {
      return key => {
        return format(
          state[target][key].startedAt,
          'MM/DD/dd HH:mm:ss',
          { locale: ko }
        )
      }
    }
  },
  roomStatus (state) {
    return target => {
      return key => {
        return state[target][key].status
      }
    }
  },
  searchRoom (state) {
    return target => {
      return key => {
        return state[target][key]
      }
    }
  }
}

const mutations = {
  [CLEAR_TEST_ROOMS] (state) {
    state.testRooms = {}
  },
  [CLEAR_PROD_ROOMS] (state) {
    state.prodRooms = {}
  },
  [CLEAR_ROOMS] (state) {
    mutations[CLEAR_TEST_ROOMS](state)
    mutations[CLEAR_PROD_ROOMS](state)
  }
}

const actions = {
  bindRooms: firebaseAction(({ bindFirebaseRef }) => {
    bindFirebaseRef('prodRooms', db.ref('room'))
    bindFirebaseRef('testRooms', testDb.ref('room'))
  }),

  unbindRooms: firebaseAction(({ unbindFirebaseRef, commit }) => {
    unbindFirebaseRef('prodRooms')
    unbindFirebaseRef('testRooms')
    db.ref('room').off()
    testDb.ref('room').off()
    commit(CLEAR_ROOMS)
  })
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
